import React from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import ReactMoment from "react-moment";
import NumberFormat from "react-number-format";
import { toast } from "react-toastify";
import qs from "qs";
import {
  MANAGER_FEE_DETAIL_QUERY,
  MANAGER_FEE_LEDGER_LIST_QUERY,
  MANAGER_FEE_LEDGER_MONTHLY_COUNT_QUERY,
} from "../../Queries";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../Components/Panel/Panel";
import { graphqlUri } from "../../../../Config/Env";
import { transactionTypeName } from "../../../../Components/User/UserNames";

export default withRouter(({ match, location, history }) => {
  const feeId = match.params.feeId;
  const queryString = qs.parse(location.search.substr(1));
  const now = new Date();
  const year = queryString.year ? parseInt(queryString.year) : now.getFullYear();
  const month = queryString.month
    ? parseInt(queryString.month)
    : now.getMonth() + 1;

  const { data: feeData } = useQuery(MANAGER_FEE_DETAIL_QUERY, {
    variables: { id: feeId },
  });
  const { data, loading } = useQuery(MANAGER_FEE_LEDGER_LIST_QUERY, {
    variables: { feeId, year, month, skip: 0, first: 1000 },
    fetchPolicy: "network-only",
  });
  const { data: countData } = useQuery(
    MANAGER_FEE_LEDGER_MONTHLY_COUNT_QUERY,
    { variables: { feeId }, fetchPolicy: "network-only" }
  );

  const countMap = {};
  if (countData && countData.ManagerFeeLedgerMonthlyCount) {
    countData.ManagerFeeLedgerMonthlyCount.forEach((c) => {
      countMap[`${c.year}-${c.month}`] = c.count;
    });
  }

  // 회비 생성월 ~ 현재월 옵션 (최신순)
  const fee = feeData && feeData.ManagerFeeDetail;
  let monthOptions = [];
  if (fee && fee.createdAt) {
    const start = new Date(fee.createdAt);
    let y = now.getFullYear();
    let m = now.getMonth() + 1;
    const sy = start.getFullYear();
    const sm = start.getMonth() + 1;
    while (y > sy || (y === sy && m >= sm)) {
      monthOptions.push({ year: y, month: m });
      m -= 1;
      if (m === 0) {
        m = 12;
        y -= 1;
      }
    }
  }
  if (!monthOptions.some((o) => o.year === year && o.month === month)) {
    monthOptions = [{ year, month }, ...monthOptions];
  }

  const onChangeMonth = (e) => {
    const [y, m] = e.target.value.split("-");
    history.push(`/manager/fees/${feeId}/ledgers?year=${y}&month=${m}`);
  };


  const result = data && data.ManagerFeeLedgerList;
  const ledgers = result ? result.ledgers : [];
  const count = result ? result.count : 0;

  // 회비 합계(잔액) — DRM 트러스트라인
  const drmTrustline =
    fee && fee.trustlines
      ? fee.trustlines.find((t) => t.currency === "DRM")
      : null;
  const feeBalance = drmTrustline ? drmTrustline.amount : 0;

  const onDownloadLedgers = async (all) => {
    try {
      const token = localStorage.getItem("token");
      const query = all
        ? `feeId=${feeId}`
        : `feeId=${feeId}&year=${year}&month=${month}`;
      const res = await fetch(`${graphqlUri}/excels/feeLedgers?${query}`, {
        method: "POST",
        mode: "cors",
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!res.ok) {
        const msg = await res.text();
        toast.error(msg || "엑셀 다운로드에 실패했습니다.");
        return;
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const suffix = all ? "전체" : `${year}-${month}`;
      a.download = `납부내역_${(fee && fee.title) || feeId}_${suffix}.xlsx`;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      a.remove();
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  return (
    <>
      <Helmet>
        <title>납부내역 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to={`/manager/fees${location.search}`}>담당 회비</Link>
          </li>
          <li className="breadcrumb-item active">납부내역</li>
        </ol>
        <h1 className="page-header">납부내역</h1>

        <div className="row m-b-15">
          <div className="col-xs-12 text-left">
            <Link
              to={`/manager/fees${location.search}`}
              className="btn btn-white"
            >
              <i className="fa fa-list m-r-5"></i>목록
            </Link>
          </div>
        </div>

        <div className="widget widget-stats bg-green m-b-15">
          <div className="stats-icon">
            <i className="fa fa-money-bill-alt"></i>
          </div>
          <div className="stats-info">
            <h4>합계</h4>
            <p>
              <NumberFormat
                value={feeBalance}
                displayType={"text"}
                thousandSeparator={true}
                suffix={" 드림"}
              />
            </p>
          </div>
        </div>

        <Panel>
          <PanelHeader noButton={true}>
            납부내역 ({count}건)
            <span className="pull-right">
              <button
                className="btn btn-white btn-xs m-l-5"
                onClick={() => onDownloadLedgers(false)}
              >
                <i className="fa fa-download m-r-5"></i>이번 달 다운로드
              </button>
              <button
                className="btn btn-white btn-xs m-l-5"
                onClick={() => onDownloadLedgers(true)}
              >
                <i className="fa fa-download m-r-5"></i>전체 다운로드
              </button>
            </span>
          </PanelHeader>
          <PanelBody>
            <div className="row m-b-10">
              <div className="col-md-3 m-b-5">
                <select
                  className="form-control"
                  value={`${year}-${month}`}
                  onChange={onChangeMonth}
                >
                  {monthOptions.map((o) => (
                    <option
                      key={`${o.year}-${o.month}`}
                      value={`${o.year}-${o.month}`}
                    >
                      {o.year}년 {o.month}월 (
                      {countMap[`${o.year}-${o.month}`] || 0}건)
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered table-striped m-b-0">
                <thead>
                  <tr>
                    <th>형태</th>
                    <th>내용</th>
                    <th>일자</th>
                    <th>금액</th>
                    <th>합계</th>
                  </tr>
                </thead>
                <tbody>
                  {(loading || count === 0) && (
                    <tr>
                      <td colSpan={5} className="text-center">
                        {loading ? "불러오는 중..." : "납부내역이 없습니다."}
                      </td>
                    </tr>
                  )}
                  {!loading &&
                    ledgers.map((ledger) => (
                      <tr key={ledger.id}>
                        <td>{transactionTypeName(ledger.transactionType)}</td>
                        <td>{ledger.title}</td>
                        <td>
                          <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                            {ledger.createdAt}
                          </ReactMoment>
                        </td>
                        <td align="right">
                          <NumberFormat
                            value={
                              ledger.transactionType === "Remittance"
                                ? -ledger.value
                                : ledger.value
                            }
                            displayType={"text"}
                            thousandSeparator={true}
                            suffix={" 드림"}
                          />
                        </td>
                        <td align="right">
                          <NumberFormat
                            value={ledger.amount}
                            displayType={"text"}
                            thousandSeparator={true}
                            suffix={" 드림"}
                          />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </PanelBody>
        </Panel>
      </div>
    </>
  );
});
